import { useEffect, useState } from "react";
import "./join.scss";

export default function Join() {
  // Smaller, delayed popup (owner request 2026-10-21): stays hidden for
  // the first seconds so visitors can see the page first, then appears.
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setOpen(true), 12000);
    return () => clearTimeout(t);
  }, []);

  // Close on Escape (registered once per open state, cleaned up properly).
  useEffect(() => {
    if (!open) return;
    const onKey = (event) => {
      if (event.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open ]);

  return (
    // <div className="join-section">
    //   <div className={`join-container ${open ? "active" : "inactive"}`}>
    //     <div
    //       className={`button ${open ? "active" : "inactive"}`}
    //       onClick={() => {
    //         setOpen(!open);
    //       }}
    //     >
    //       {/* {!open ? "Join Now!" : "Close"} */}
    // <svg
    //   version="1.1"
    //   xmlns="http://www.w3.org/2000/svg"
    //   x="0px"
    //   y="0px"
    //   width="300px"
    //   height="300px"
    //   viewBox="0 0 300 300"
    //   enable-background="new 0 0 300 300"
    // >
    //   <defs>
    //     <path
    //       id="circlePath"
    //       d="M 150, 150 m -60, 0 a 60,60 0 0,1 120,0 a 60,60 0 0,1 -120,0 "
    //     />
    //   </defs>
    //   <circle cx="150" cy="100" r="75" fill="none" />
    //   <g>
    //     <use href="#circlePath" fill="none" />
    //     <text fill="#000">
    //       <textPath href="#circlePath">Chat Now! Chat Now!</textPath>
    //     </text>
    //   </g>
    // </svg>
    //     </div>
    //   </div>
    //   <div className={`flex content ${open ? "active" : "inactive"}`}>
    //     <div
    //       className="exit"
    //       onClick={() => {
    //         setOpen(!open);
    //       }}
    //     >
    //       <div className="x top"></div>
    //       <div className="x bottom"></div>
    //     </div>
    //     <h1>Chat</h1>
    //   </div>
    // </div>

    <section className={`join-section ${open ? "active" : "inactive"}`}>
      <div className="join-container">
        <div className="join-border">
          <div
            className="exit"
            onClick={() => {
              setOpen(!open);
            }}
          >
            <div className="x top"></div>
            <div className="x bottom"></div>
          </div>
          <h1>25TH ANNIVERSARY 🎉</h1>
          <div className="promotion-container">
            <p className="popup-lead">
              New to Taekwondo? Try 1 class FREE — no card, no
              commitment.
            </p>
            <a className="pay-button" href="https://skytkd.us/#trial">
              Book My FREE Class
            </a>
            <p className="popup-uniform">
              Finish your free trial and sign up for regular classes —
              get a FREE uniform.
            </p>
            <p className="pay-proof">
              ★★★★★ Our Basking Ridge location is rated 5.0 stars from
              9 Google reviews
            </p>
            <div className="how-it-works">
              <p className="how-title">How it works</p>
              <ol>
                <li>Book your free class online</li>
                <li>We email you to schedule your first class</li>
                <li>Train at Clinton or Basking Ridge</li>
              </ol>
            </div>
            <p className="text-alt">
              Questions?{" "}
              <a href="mailto:pskyman1@gmail.com">Email us at pskyman1@gmail.com</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
